import React from 'react';
import { Typewriter } from 'react-simple-typewriter';

const FosteringText = () => {
  const words = [
    ' Inclusivity',
    ' Integrity',
    ' Respect',
    ' Innovation',
    ' Collaboration',
  ];

  return (
    <h1 className="text1">
      Promoting
      <span className='text-gender-equality ms-1'>
        <Typewriter
          words={words}
          loop={true}
          cursor
          deleteSpeed={50}
          typeSpeed={100}
        />
      </span>
    </h1>
  );
};

export default FosteringText;
